import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {LocalCustomerSettingService} from '../service/local-customer.service';
import {LocalCustomerSettingsModel} from '../../../../models/LocalCustomerSettingsModel';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-new-local-customer',
  templateUrl: './new-local-customer.component.html',
  styleUrls: ['./new-local-customer.component.scss']
})
export class NewLocalCustomerComponent extends ProjectConstants implements OnInit, OnDestroy {

  showActions: boolean;

  localCustomerSetting: LocalCustomerSettingsModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  saveLocalCustomer: Subscription;

  showLC: boolean;
  showRegion: boolean;
  registerForm: FormGroup;
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router,
              private localCustomerSettingService: LocalCustomerSettingService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService) {
    super();

    this.showActions = false;
    this.showLC  = false;
    this.showRegion  = false;
    this.localCustomerSetting = new LocalCustomerSettingsModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();

  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required]
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.saveLocalCustomer = this.localCustomerSettingService.save(this.localCustomerSettingService.baseUrl, this.localCustomerSetting)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, Local Customer already exists', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Local customer Setting was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 0}});
            }
          },
            error => {
              this.loaderService.display(false);
              toastr.error('Local Customer Setting was not created', 'Error');
            });
    }
  }

  ngOnDestroy(): void {
    if (this.saveLocalCustomer) {
      this.saveLocalCustomer.unsubscribe();
    }
  }

  getElementSelectedLC($event) {
    this.localCustomerSetting.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.localCustomerSetting.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


  resetLc() {
    this.registerForm.patchValue({
      localCustomerCod: ''
    });
    this.localCustomerSelect = new LocalCustomerModel();
  }

  resetRegion() {
    this.registerForm.patchValue({
      region: ''
    });
    this.regionSelect = new RegionModel();
  }

  reset(){
    this.resetRegion();
    this.resetLc();
  }

  isValidInput(value: AbstractControl) {
    if (value.value !== null) {
      if (value.value !== '' && value.valid) {
        return 'is-valid';
      } else {
        return 'is-invalid';
      }
    } else {
      return 'is-invalid';
    }
  }
}

